import { useOffers } from "@features/offers"
import type { Offer } from "../models/offers"

export function useOfferById(offerId?: string): Offer | undefined {
  const { isLoading, data } = useOffers()

  if (isLoading || !data) return

  return data.find(
    (o: Offer) =>
      offerId !== undefined &&
      Number.parseInt(o.CustomOfferID, 10) === Number.parseInt(offerId, 10),
  )
}
